import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/styles.scss'   // 历史工具类（统一墨青）
import '@/assets/style/tokens.scss'   // 设计 token（SCSS 变量 + :root CSS 变量）
import '@/assets/style/base.scss'     // 通用基础类（btn/card/tag/field/timeline/segmented/switch）
import '@/assets/style/demo.scss'     // baoming 专用组件（expo-banner/steps/form-section/contract-card/hero 等）
import 'vant/lib/index.css';
import AppIcon from '@/components/AppIcon.vue'
// [2026-09-13 修复] step6 使用 <van-popup>，但项目此前只 import 了 vant 样式 + 方法式组件
// （showToast/showConfirmDialog 自带挂载，无需注册），从未注册 Popup 组件本身。
// 结果 <van-popup> 被 Vue 当作未知原生标签渲染：编辑表单长期内联渲染在页面底部，
// editorVisible 开关没有任何视觉效果 → 「新建 / 新建产品 / 关联新产品」点了"没反应"、无法添加产品。
import { Popup } from 'vant'

// import VueQrcode from 'vue-qrcode'
const app = createApp(App)
// app.component('VueQrcode', VueQrcode)
app.component('AppIcon', AppIcon)   // 全局注册 SVG 图标组件
app.use(Popup)                      // 注册 van-popup（withInstall 注册 'van-popup' / 'VanPopup'）
app.use(router)
app.use(store)

// ============================================================
// [会议入口] 支持按会议分享入口：https://host/m/:meetingId
// hash 路由下 pathname 保留，启动时解析并写入 store；
// 未登录 → 守卫带 redirect 落登录页，登录后跳过选会直进该会议；
// 已登录 → 直进步骤首页。短路径示例：/m/47
// ============================================================
const mEntry = window.location.pathname.match(/^\/m\/(\d+)/)
if (mEntry) {
  store.commit('_setMeetingId', mEntry[1])
  const entryHash = window.location.hash
  // [真实展会修复] 会议入口统一先到 /home，由 _actionStaus 判断加载既有报名还是新报名；
  // 避免短链残留 #/step1 等步骤 hash 时直接进入新报名表单。
  if (!entryHash || entryHash === '#/' || /^#\/(home|step)/.test(entryHash)) {
    window.location.replace(window.location.origin + window.location.pathname + '#/home')
  }
}

app.mount('#app')
